import React from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/button';
import PermissionRestrict from 'hoc/PermissionRestrict';

import { ROLES } from 'permissions/constants';

import search from 'assets/icons/no-record.svg';
import plusIcon from 'assets/images/whiteAddIcon.svg';
import style from './add.module.scss';

const AddClient = ({ modalHeight = '600px', showLabel = true }) => {
  return (
    <div className={style.mainAddClient}>
      {' '}
      {showLabel && <p className={style.attorney}>Clients</p>}
      <div className={style.innerAdd} style={{ height: modalHeight }}>
        <img src={search} alt="" className={style.img} />
        <p className={style.record}>No records</p>
        <PermissionRestrict roles={[ROLES.ADMIN, ROLES.EDITOR]}>
          <Link to="/clients/add" style={{ textDecoration: 'none' }}>
            <Button
              text={'Add Client'}
              iconStart={plusIcon}
              btnClass={style.btnClass}
            />
          </Link>
        </PermissionRestrict>
      </div>
    </div>
  );
};

export default AddClient;
